import { connectWallet, disconnectWallet, getSavedWallet } from './wallet-auth.js';
import { initPlayerPanel, refreshPlayerPanel } from './player-panel.js';
import { refreshHatInventory, clearHatInventory } from './hat-inventory.js';

/** Initialize auth UI — wallet connect / logout / panel refresh.
 *  X/Twitter login was removed; Solana wallet is the sole identity provider. */
export async function initAuth(): Promise<void> {
  initPlayerPanel();
  const walletBtn = document.getElementById('wallet-btn') as HTMLButtonElement | null;
  const userProfile = document.getElementById('user-profile');
  const userAvatar = document.getElementById('user-avatar') as HTMLImageElement | null;
  const userName = document.getElementById('user-name');
  const logoutBtn = document.getElementById('logout-btn');

  walletBtn?.addEventListener('click', async () => {
    const result = await connectWallet();
    if (result) {
      showWalletLoggedIn(result.address, result.name, walletBtn, userProfile, userAvatar, userName);
    }
  });

  logoutBtn?.addEventListener('click', async () => {
    await disconnectWallet();
    showLoggedOut(walletBtn, userProfile);
  });

  // Restore saved wallet session if any
  const savedWallet = getSavedWallet();
  if (savedWallet) {
    showWalletLoggedIn(savedWallet.address, savedWallet.name, walletBtn, userProfile, userAvatar, userName);
  }
}

function showWalletLoggedIn(
  address: string,
  displayName: string,
  walletBtn: HTMLElement | null,
  userProfile: HTMLElement | null,
  userAvatar: HTMLImageElement | null,
  userName: HTMLElement | null,
): void {
  if (walletBtn) walletBtn.style.display = 'none';
  if (userProfile) userProfile.style.display = 'block';
  if (userAvatar) userAvatar.style.display = 'none';
  if (userName) userName.textContent = displayName;

  (window as any).__currentUser = {
    id: address,
    name: displayName,
    avatar: null,
    provider: 'solana',
    walletAddress: address,
  };

  // Pull stats + display name from server (overrides default short address if set)
  refreshPlayerPanel(address);
  // Warm the hat inventory cache so chest rolls can avoid duplicates
  // without a synchronous fetch.
  void refreshHatInventory();
}

function showLoggedOut(
  walletBtn: HTMLElement | null,
  userProfile: HTMLElement | null,
): void {
  if (walletBtn) walletBtn.style.display = 'block';
  if (userProfile) userProfile.style.display = 'none';
  (window as any).__currentUser = null;
  clearHatInventory();
}
